// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes zoomIn95{0%{opacity:0;transform:scale3d(.95,.95,.95)}to{opacity:1}}.main-panel .zoomIn{animation-name:zoomIn95}@keyframes zoomOut95{0%{opacity:1}to{opacity:0;transform:scale3d(.95,.95,.95)}}.main-panel .zoomOut{animation-name:zoomOut95}", ""]);
// Exports
module.exports = exports;
